var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeAberto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1449_884)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "#5182FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 49.5,
    stroke: "#7D7D7D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 80,
    height: 80,
    rx: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1449_884",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1449_884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1449_884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1449_884",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1449_884",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAberto);
export default __webpack_public_path__ + "static/media/iconeAberto.aa27f3764746aa72a2b7f42e6ebaa52c.svg";
export { ForwardRef as ReactComponent };